import { RugbyUnionIncidentId } from '@collector/sportsapi-client-legacy'

import { IncidentIdsGroup } from '../../../configuration'

export const incidentIdsGroup: IncidentIdsGroup = {
  name: 'Substitution',
  incidentIds: [
    RugbyUnionIncidentId.SubstitutionOut,
    RugbyUnionIncidentId.SubstitutionIn,
  ],
}
